import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getUserProfile(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/user/profile.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function patchUserProfile(axiosPrivate, cb, data) {
	return axiosPrivate
		.patch(`${apiURL}/user/profile.json`, data)
		.then((res) => {
			if (res.status === 200 || res.status === 202 || res === undefined) {
				toast.success("Personal data - updated");
				cb();
				return res;
			} else {
				toast.error("Personal data - not updated, try again");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addUserAvatar(axiosPrivate, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/user/profile/avatar.json`, data)
		.then((res) => {
			if ((res.status > 199) & (res.status < 300)) {
				toast.success("Avatar - added");
				cb();
				return res;
			} else {
				toast.error("Avatar - failed to be added, try again");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function postChangeUserPassword(axiosPrivate, data) {
	return axiosPrivate
		.post(`${apiURL}/user/change-password.json`, data)
		.then((res) => {
			if ((res.status > 199) & (res.status < 300)) {
				toast.success("Password - changed");
				return res;
			} else {
				throw new Error(res);
			}
		})
		.catch((err) => {
			return err.response;
		});
}
